import React, { useState, useEffect } from 'react';
import { Target } from 'lucide-react';
import { aboutService } from '../services/api';

function ScopeObjectives() {
  const [aboutObjectives, setAboutObjectives] = useState([]);
  const [aboutSpecializedFields, setAboutSpecializedFields] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await aboutService.get();
        if (response.data) {
          if (response.data.objectives) {
            try {
              const parsed = JSON.parse(response.data.objectives);
              if (Array.isArray(parsed)) {
                setAboutObjectives(parsed);
              }
            } catch (e) {
              console.error('Error parsing about objectives:', e);
            }
          }
          if (response.data.specializedFields) {
            try {
              const parsed = JSON.parse(response.data.specializedFields);
              if (Array.isArray(parsed)) {
                setAboutSpecializedFields(parsed);
              }
            } catch (e) {
              console.error('Error parsing about specializedFields:', e);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching scope objectives:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">اهداف و دامنه</h1>
          <p className="text-xl text-blue-100">دامنه تخصصی و اهداف نشریه مجری</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <Target className="text-blue-700" size={28} />
            اهداف نشریه
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {aboutObjectives.map((goal, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6 border-r-4 border-blue-700">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 text-2xl">
                    {goal.icon}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">{goal.title}</h3>
                    <p className="text-gray-600 text-sm">{goal.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="text-3xl font-bold text-gray-900 mb-6">دامنه تخصصی</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {aboutSpecializedFields.map((field, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6 flex items-start gap-3">
                <span className="text-2xl" role="img" aria-label="icon">{field.icon}</span>
                <div>
                  <h3 className="text-gray-900 font-bold">{field.title}</h3>
                  {field.description && <p className="text-gray-600 text-sm mt-1">{field.description}</p>}
                </div>
              </div>
            ))}
          </div>
        </section>

        {aboutObjectives.length === 0 && aboutSpecializedFields.length === 0 && (
          <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ScopeObjectives;
